// ── SettlementDot 공용 상수 ────────────────────────────────────────────────────
// 색상 팔레트, 그림자, 날짜순 뷰 타입 설정

// ── 색상 팔레트 — dark mode: CSS 변수 토큰 사용 ──────────────────────────────
export const C = {
  bg:          'var(--bg)',
  card:        'var(--bg-card)',
  border:      'var(--border)',
  borderLight: 'var(--border)',
  main:        'var(--text)',
  sub:         'var(--text-muted)',
  subDark:     'var(--text-sub)',
  accent:      '#6366f1',
  accentBg:    '#eef2ff',
  accentBdr:   '#c7d2fe',
  plus:        '#10b981',
  plusBg:      '#d1fae5',
  minus:       '#ef4444',
  minusBg:     '#fee2e2',
  warn:        '#f59e0b',
  warnBg:      '#fef3c7',
  // 히어로 배경: 라이트 = 브랜드 네이비 그라데이션, 다크 = --std-navy-*(차콜, 2026-09-28) (var(--text)는 다크에서 흰색이라 사용 불가)
  heroTop:     'var(--std-navy-subtle, #152b63)',  // 라이트 pine-700 네이비
  heroBot:     'var(--std-navy-surface, #0f1b35)',  // 라이트 pine-900 네이비
};

/** 공통 그림자 프리셋 */
export const shadow = {
  sm: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  md: '0 4px 6px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.04)',
  lg: '0 10px 15px rgba(0,0,0,0.08), 0 4px 6px rgba(0,0,0,0.04)',
};

/** 날짜순 뷰 항목 타입별 레이블·색상 설정 */
export const TYPE_CFG = {
  contract:   { label: '계약차감', bg: '#fee2e2', color: '#dc2626' },
  delivery:   { label: '택배비',   bg: '#fef3c7', color: '#b45309' },
  promo:      { label: '홍보물',   bg: '#fef3c7', color: '#b45309' },
  promo_pending: { label: '홍보물 예정', bg: '#fffbeb', color: '#b45309' },
  card:       { label: '카드',     bg: '#dbeafe', color: '#1d4ed8' },
  phone:      { label: '전화',     bg: '#ede9fe', color: '#7c3aed' },
  deposit:    { label: '입금',     bg: '#d1fae5', color: '#059669' },
  settlement:             { label: '정산지급',   bg: '#ccfbf1', color: '#0d9488' },
  consultant_share:       { label: '상담자배분', bg: '#fce7f3', color: '#be185d' },  // 상담자 배분 차감
  consultant_share_income: { label: '상담자배분', bg: '#fce7f3', color: '#be185d' }, // 상담자 배분 수입
  consultant_charge:       { label: '1:1급여', bg: '#fee2e2', color: '#dc2626' },
  others:                  { label: '기타',      bg: '#fffbeb', color: '#b45309' }, // 기타 수입
  // 계약 취소/복원 이벤트 — 금액 0원 표시, 상태 변경 기록용
  cancel:     { label: '계약차감', bg: '#fee2e2', color: '#dc2626' },  // 계약취소: 빨간 뱃지
  restore:    { label: '계약차감', bg: '#d1fae5', color: '#059669' },  // 계약복원: 초록 뱃지
};
